import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import Chip from '../../../Chip';
import Scoring from '../../../Scoring';

import Price from '../../common/Price';

import Tag from '../../../Tag';

import styles from './HomecardContent.module.scss';
import HomecardContentDescription from './HomecardContentDescription';

const HomecardContentSimplified = ({
  availableFrom,
  title,
  link,
  target,
  onClick,
  price,
  chips,
  withTransparentBackground, // To review if necessary (all of our homecards are white)
  onMoreInfoClick,
  hasDescription,
  offerDiscount,
  isEmbedded,
  scoring,
  className
}) => {
  const hasChips = chips.length;

  return (
    <div
      className={classNames(
        styles['homecard-content'],
        styles['homecard-content--redesign'],
        {
          [styles['homecard-content--with-transparent-background']]:
            withTransparentBackground
        },
        className
      )}
      data-test="homecard-content"
    >
      <a
        className={styles['homecard-content__header']}
        href={link}
        target={target}
        onClick={onClick}
        data-test="homecard-link"
      >
        <div
          className={classNames(
            styles['homecard-content__info-container'],
            styles['homecard-content__info-container--redesign']
          )}
        >
          <Chip
            label={trans('homecard.available-from.rebranding', {
              ordinalDate: availableFrom
            })}
            colorSchema="lightTag"
            size="xsmall"
            className={styles['homecard-content__available-from--with-tag']}
          />
          {scoring?.score ? (
            <div className={styles['homecard-content__scoring-container']}>
              <Scoring score={430} totalReviews={scoring.totalBookingsClosed} />
            </div>
          ) : null}
        </div>
        <p
          className={classNames(styles['homecard-content__title'], {
            [styles['homecard-content__title--embedded']]: isEmbedded
          })}
        >
          {title}
        </p>
        {hasChips ? (
          <div
            className={classNames(
              styles['homecard-content__label-container'],
              styles['homecard-content__label-container--redesign']
            )}
          >
            {chips.map(chip => (
              <Chip
                key={chip.id}
                colorSchema="lightTag"
                size="xsmall"
                {...chip}
              />
            ))}
          </div>
        ) : null}
      </a>
      <div className={styles['homecard-content__footer']}>
        <div
          className={classNames(
            styles['homecard-content__price-container'],
            styles['homecard-content__price-container--redesign']
          )}
        >
          <Price
            {...price}
            color="dark"
            className={styles['homecard-content__price']}
            biggerFont={isEmbedded}
            biggerFontMonthly={isEmbedded}
          />
          {offerDiscount && (
            <Tag
              className={styles['homecard-content__price-tag']}
              colorSchema="pink"
              size="small"
              label={trans('homecard.label.up_to_discount', {
                discount: offerDiscount
              }).toUpperCase()}
            />
          )}
        </div>
        {hasDescription && (
          <HomecardContentDescription
            position="bottom"
            onMoreInfoClick={onMoreInfoClick}
          />
        )}
      </div>
    </div>
  );
};

export default HomecardContentSimplified;
